<template>
	<v-dialog v-model="isDialogShow" persistent max-width="460">
		<v-card>
			<v-card-title class="font-size-14 justify-start">Gagal Transfer</v-card-title>
			<v-card-text class="text-left">
				<v-alert
					text
					prominent
					type="error"
					icon="mdi-alert"
					class="mb-5"
					v-if="msg"
				>
					{{ msg }}
				</v-alert>
				<div class="d-block text-left mb-3" v-if="Object.keys(data).length > 0">
					<div class="d-flex">
						<div class="pa-0 col-6 col-sm-4">Kode Penerima</div>
						<div class="pa-0 col-6 col-sm-8 font-weight-bold text-uppercase">: {{ data.code }}</div>
					</div>
					<div class="pt-1 d-flex">
						<div class="pa-0 col-6 col-sm-4">Nama Penerima</div>
						<div class="pa-0 col-6 col-sm-8 font-weight-bold">: {{ data.name }}</div>
					</div>
					<div class="pt-1 d-flex">
						<div class="pa-0 col-6 col-sm-4">Nominal Transfer</div>
						<div class="pa-0 col-6 col-sm-8 font-weight-bold">: {{ data.nominal | toRupiah }}</div>
					</div>
				</div>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="grey darken-1" outlined class="text-capitalize" @click.stop="modalHide">{{ closeText }}</v-btn>
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	data () {
		return {
			isDialogShow: false,
			btnLoading: false,
			closeText: 'Tutup',
		}
	},
	props: ['msg', 'data'],
	computed: {
	},
	methods: {
		modalHide() {
			this.isDialogShow = false
		},
		modalShow() {
			this.isDialogShow = true
		},
	}
};
</script>